


import { useState, useEffect } from "react";
import { ProSidebar, Menu, MenuItem, SubMenu } from "react-pro-sidebar";
import { Box, IconButton, Typography, Tooltip, useTheme, useMediaQuery } from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import "react-pro-sidebar/dist/css/styles.css";
import { tokens } from "../../theme";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import PeopleOutlineOutlinedIcon from "@mui/icons-material/PeopleOutlineOutlined";
import BadgeOutlinedIcon from "@mui/icons-material/BadgeOutlined";
import DesignServicesOutlinedIcon from "@mui/icons-material/DesignServicesOutlined";
import LocalShippingOutlinedIcon from "@mui/icons-material/LocalShippingOutlined";
import BuildCircleOutlinedIcon from "@mui/icons-material/BuildCircleOutlined";
import CheckroomOutlinedIcon from "@mui/icons-material/CheckroomOutlined";
import ReceiptOutlinedIcon from "@mui/icons-material/ReceiptOutlined";
import FeedbackOutlinedIcon from "@mui/icons-material/FeedbackOutlined";
import PaymentOutlinedIcon from "@mui/icons-material/PaymentOutlined";
import ScheduleOutlinedIcon from "@mui/icons-material/ScheduleOutlined";
import TextureOutlinedIcon from "@mui/icons-material/TextureOutlined";
import Inventory2OutlinedIcon from "@mui/icons-material/Inventory2Outlined";
import StraightenOutlinedIcon from "@mui/icons-material/StraightenOutlined";

import CalendarTodayOutlinedIcon from "@mui/icons-material/CalendarTodayOutlined";
import BarChartOutlinedIcon from "@mui/icons-material/BarChartOutlined";
import PieChartOutlineOutlinedIcon from "@mui/icons-material/PieChartOutlineOutlined";
import TimelineOutlinedIcon from "@mui/icons-material/TimelineOutlined";
import MenuOutlinedIcon from "@mui/icons-material/MenuOutlined";
import MapOutlinedIcon from "@mui/icons-material/MapOutlined";
import ManageAccountsOutlinedIcon from '@mui/icons-material/ManageAccountsOutlined';
import SubscriptionsOutlinedIcon from '@mui/icons-material/SubscriptionsOutlined';

import ListIcon from "@mui/icons-material/List";
import CategoryOutlinedIcon from "@mui/icons-material/CategoryOutlined"; 
import FilterListIcon from "@mui/icons-material/FilterListOutlined"; 

import { useUser } from "../../common/UserContext";

import LogOffIcon from "@mui/icons-material/LogoutOutlined"; 

const Item = ({ title, to, icon, selected, setSelected }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  
  return (
    <MenuItem
      active={selected === title}
      style={{
        color: colors.grey[100],
      }}
      onClick={() => setSelected(title)}
      icon={icon}
    >
      <Typography>{title}</Typography>
      <Link to={to} />
    </MenuItem>
  );
};

const Sidebar = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [isCollapsed, setIsCollapsed] = useState(isMobile);
  const [selected, setSelected] = useState("Dashboard");

  const { appUserFirstName, appUserLastName, appUserRole } = useUser();

  const navigate = useNavigate();

/*  B E G I N    S H R I N K S    T H E    M E N U   H E I G H T  B A C K  100%  */
    useEffect(() => {
      
    // Function to update the height

      const timer = setTimeout(() => {
      //  alert(`Selected: ${selected}`);

        const totalHeight = 100;
      setBoxHeight(totalHeight + 'hv');

      }, 1000); // Delay the alert by 10 seconds
     
      return () => clearTimeout(timer); // Clean up the timer when the component unmounts or before the next effect runs

    }, [selected]); // This effect depends on 'selected' and runs when it changes

  /*  E N D    S H R I N K S    T H E    M E N U   H E I G H T  B A C K  100%  */

    
/*    B E G I N    C O D E    T O    M A K E    S U R E    S I D E    B A R    M A T C H   S C R O L L A B L E   A R E A    */  
const [boxHeight, setBoxHeight] = useState('auto');

useEffect(() => {
  // Function to update the height
  const updateHeight = () => {

    // Set the height to the total scrollable height of the document
    const totalHeight = document.documentElement.scrollHeight;
    setBoxHeight(totalHeight + 'px');
  };

   // Instantiate and configure MutationObserver
   const observer = new MutationObserver(mutations => {
    updateHeight();
  });

  // Start observing the body for DOM changes
  observer.observe(document.body, {
    childList: true,      // Observe direct children changes
    subtree: true,        // Observe all descendants
    attributes: true,     // Observe attributes changes
    characterData: true   // Observe text changes
  });

  // Update the height initially and on window resize
  updateHeight();
  window.addEventListener('resize', updateHeight);

  // Cleanup listener when component unmounts
  return () => {
    window.removeEventListener('resize', updateHeight);
    observer.disconnect();
  };
}, []);

/*    E N D     C O D E    T O    M A K E    S U R E    S I D E    B A R    M A T C H   S C R O L L A B L E   A R E A    */  

  return (

    <Box
    sx={{...(!isCollapsed ? { minWidth: '370px' } : {}),
      height: boxHeight, // Apply the dynamic height
      borderRight: "1px solid #5d5d5d",
      "& .pro-sidebar-inner": {
        background: `${colors.primary[600]} !important`,
      },
      "& .pro-icon-wrapper": {
        backgroundColor: "transparent !important",
      },
      "& .pro-inner-item": {
        padding: "5px 35px 5px 20px !important",
      },
      "& .pro-inner-item:hover": {
        color: "#868dfb !important",
      },
      "& .pro-menu-item.active": {
        color: "#6870fa !important",
      },
    }}
  >
    <ProSidebar collapsed={isCollapsed} style={isMobile ? {} : {...(!isCollapsed ? { width: '100%' } : {})}}>
      <Menu iconShape="square">
        {/* LOGO AND MENU ICON */}

        {!isMobile && 
        <MenuItem
          onClick={() => setIsCollapsed(!isCollapsed)}
          icon={isCollapsed ? <MenuOutlinedIcon /> : undefined}
          style={{
            margin: "10px 0 20px 0",
            color: colors.grey[100],
          }}
        >
          {!isCollapsed && (
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              ml="15px"
            >
              <Typography variant="h3" color={colors.grey[100]}> 
                 {/* ADMINIS */}
              </Typography>
              <IconButton onClick={() => setIsCollapsed(!isCollapsed)}>
                <MenuOutlinedIcon />
              </IconButton>
            </Box>
          )}
        </MenuItem>
        }

        {!isCollapsed && (
          <Box mb="25px">
            <Box display="flex" justifyContent="center" alignItems="center">
              <img
                alt="profile-user"
                width="100px"
                height="100px"
                src={`../../assets/logo.png`}
                style={{ cursor: "pointer", borderRadius: "50%" }} 
                 onClick={() => window.location.href = "/"}
              />
            </Box>
            <Box textAlign="center">
              <Typography
                variant="h3"
                sx={{ m: "10px 0 0 0" }} style={{ cursor: "pointer", borderRadius: "50%" }} 
                 onClick={() => window.location.href = "/"}
              >
               GoTailo
              </Typography>
              <Typography variant="h5" color={colors.greenAccent[500]} style={{ cursor: "pointer", borderRadius: "50%" }} 
                 onClick={() => window.location.href = "/"}>
                Tailor Platform
              </Typography>
            </Box>
          </Box>
        )}

        <Box paddingLeft={isCollapsed ? undefined : "10%"}>
          <Item
            title="Dashboard"
            to="/app"
            icon={<HomeOutlinedIcon />}
            selected={selected}
            setSelected={setSelected}
          />

          <Tooltip title="These are the foundational records your account needs to function smoothly." arrow 
           PopperProps={{
              modifiers: [
                {
                  name: 'offset',
                  options: {
                    offset: [0, 8],
                  },
                },
              ],
              sx: {
                '& .MuiTooltip-tooltip': {
                  fontSize: '16px',
                  padding: '8px 12px', // optional, for better readability
                },
              },
            }}
          >
            <Typography
              variant="h6"
              color={colors.grey[300]}
              sx={{ m: "15px 0 5px 20px" }}
            >
              Essentials
            </Typography>
          </Tooltip>

          
                <Item
                title="Service Categories"
                to="/servicecategories"
                icon={<CategoryOutlinedIcon />}
                selected={selected}
                setSelected={setSelected}
                />

            
                <Item
                title="Customers"
                to="/customers"
                icon={<PeopleOutlineOutlinedIcon />}
                selected={selected}
                setSelected={setSelected}
                />

            
                <Item
                title="Staff"
                to="/staff"
                icon={<BadgeOutlinedIcon />}
                selected={selected}
                setSelected={setSelected}
                />

            
                <Item
                title="Tailoring Services"
                to="/tailoringservices"
                icon={<DesignServicesOutlinedIcon />}
                selected={selected}
                setSelected={setSelected}
                />

            
                <Item
                title="Suppliers"
                to="/suppliers"
                icon={<LocalShippingOutlinedIcon />}
                selected={selected}
                setSelected={setSelected}
                />

            

          <Tooltip title="These are the day-to-day records you’ll create and manage as part of running your organization." arrow 
           PopperProps={{
            modifiers: [
              {
                name: 'offset',
                options: {
                  offset: [0, 8],
                },
              },
            ],
            sx: {
              '& .MuiTooltip-tooltip': {
                fontSize: '16px',
                padding: '8px 12px', // optional, for better readability
              },
            },
          }}
          >
            <Typography
              variant="h6"
              color={colors.grey[300]}
              sx={{ m: "15px 0 5px 20px" }}
            >
              {isCollapsed ? 'Daily' : 'Daily Activities'}

            </Typography>
          </Tooltip>

          
  
              {!isMobile &&
                  <SubMenu
                    title="Customizations"
                  to="/customizations"
                    icon={<BuildCircleOutlinedIcon />}
                    defaultOpen={false} // Control initial open state
                    style={{ color: colors.grey[100] }}
                    onClick={() => {
                    
                      if (!selected.includes("Customization"))
                      {
                        setSelected("Customization List");
                        navigate("/customizations/list");
                      }
                    }}
                  >
                    <Item
                      title="Customization List"
                      to="/customizations/list"
                      icon={<ListIcon />}
                      selected={selected}
                      setSelected={setSelected}
                    />

                    

                    
                

                <Item
                title="Customizations by Type"
                to="/customizations/type"
                icon={<CategoryOutlinedIcon />}
                selected={selected}
                setSelected={setSelected}
              />

              

                  </SubMenu>
                }
  
                {isMobile && 
                  <Item
                  title="Customizations"
                  to="/customizations"
                  icon={<BuildCircleOutlinedIcon />}
                  selected={selected}
                  setSelected={setSelected}
                  />

                }
                   
                  <Item
                  title="Garments"
                  to="/garments"
                  icon={<CheckroomOutlinedIcon />}
                  selected={selected}
                  setSelected={setSelected}
                  />

                   
  
              {!isMobile &&
                  <SubMenu
                    title="Orders"
                  to="/orders"
                    icon={<ReceiptOutlinedIcon />}
                    defaultOpen={false} // Control initial open state
                    style={{ color: colors.grey[100] }}
                    onClick={() => {
                    
                      if (!selected.includes("Order"))
                      {
                        setSelected("Order List");
                        navigate("/orders/list");
                      }
                    }}
                  >
                    <Item
                      title="Order List"
                      to="/orders/list"
                      icon={<ListIcon />}
                      selected={selected}
                      setSelected={setSelected}
                    />

                    

                    
                

                <Item
                title="Orders by Order Status"
                to="/orders/orderstatus"
                icon={<CategoryOutlinedIcon />}
                selected={selected}
                setSelected={setSelected}
              />

              
                

                <Item
                title="Orders by Payment Status"
                to="/orders/paymentstatus"
                icon={<CategoryOutlinedIcon />}
                selected={selected}
                setSelected={setSelected}
              />

              
                

                <Item
                title="Orders by Payment Method"
                to="/orders/paymentmethod"
                icon={<CategoryOutlinedIcon />}
                selected={selected}
                setSelected={setSelected}
              />

              

                  </SubMenu>
                }
  
                {isMobile && 
                  <Item
                  title="Orders"
                  to="/orders"
                  icon={<ReceiptOutlinedIcon />}
                  selected={selected}
                  setSelected={setSelected}
                  />

                }
                   
  
              {!isMobile &&
                  <SubMenu
                    title="Customer Feedback"
                  to="/customerfeedback"
                    icon={<FeedbackOutlinedIcon />}
                    defaultOpen={false} // Control initial open state
                    style={{ color: colors.grey[100] }}
                    onClick={() => {
                    
                      if (!selected.includes("Customer Feedback"))
                      {
                        setSelected("Customer Feedback List");
                        navigate("/customerfeedback/list");
                      }
                    }}
                  >
                    <Item
                      title="Customer Feedback List"
                      to="/customerfeedback/list"
                      icon={<ListIcon />}
                      selected={selected}
                      setSelected={setSelected}
                    />

                    

                    
                

                <Item
                title="Customer Feedback by Resolution Status"
                to="/customerfeedback/resolutionstatus"
                icon={<CategoryOutlinedIcon />}
                selected={selected}
                setSelected={setSelected}
              />

              

                  </SubMenu>
                }
  
                {isMobile && 
                  <Item
                  title="Customer Feedback"
                  to="/customerfeedback"
                  icon={<FeedbackOutlinedIcon />}
                  selected={selected}
                  setSelected={setSelected}
                  />

                }
                   
                  <Item
                  title="Tailor Performance"
                  to="/tailorperformance"
                  icon={<BarChartOutlinedIcon />}
                  selected={selected}
                  setSelected={setSelected}
                  />

                   
  
              {!isMobile &&
                  <SubMenu
                    title="Appointments"
                  to="/appointments"
                    icon={<CalendarTodayOutlinedIcon />}
                    defaultOpen={false} // Control initial open state
                    style={{ color: colors.grey[100] }}
                    onClick={() => {
                    
                      if (!selected.includes("Appointment"))
                      {
                        setSelected("Appointment List");
                        navigate("/appointments/list");
                      }
                    }}
                  >
                    <Item
                      title="Appointment List"
                      to="/appointments/list"
                      icon={<ListIcon />}
                      selected={selected}
                      setSelected={setSelected}
                    />

                    

                    
                

                <Item
                title="Appointments by Payment Status"
                to="/appointments/paymentstatus"
                icon={<CategoryOutlinedIcon />}
                selected={selected}
                setSelected={setSelected}
              />

              
                

                <Item
                title="Appointments by Appointment Type"
                to="/appointments/appointmenttype"
                icon={<CategoryOutlinedIcon />}
                selected={selected}
                setSelected={setSelected}
              />

              

                  </SubMenu>
                }
  
                {isMobile && 
                  <Item
                  title="Appointments"
                  to="/appointments"
                  icon={<CalendarTodayOutlinedIcon />}
                  selected={selected}
                  setSelected={setSelected}
                  />

                }
                   
  
              {!isMobile &&
                  <SubMenu
                    title="Payments"
                  to="/payments"
                    icon={<PaymentOutlinedIcon />}
                    defaultOpen={false} // Control initial open state
                    style={{ color: colors.grey[100] }}
                    onClick={() => {
                    
                      if (!selected.includes("Payment"))
                      {
                        setSelected("Payment List");
                        navigate("/payments/list");
                      }
                    }}
                  >
                    <Item
                      title="Payment List"
                      to="/payments/list"
                      icon={<ListIcon />}
                      selected={selected}
                      setSelected={setSelected}
                    />

                    
               
                    <Item
                      title="Payments by Status"
                      to="/payments/status"
                      icon={<CategoryOutlinedIcon />}
                      selected={selected}
                      setSelected={setSelected}
                    />

              

                    
                

                <Item
                title="Payments by Currency"
                to="/payments/currency"
                icon={<CategoryOutlinedIcon />}
                selected={selected}
                setSelected={setSelected}
              />

              
                

                <Item
                title="Payments by Billing Cycle"
                to="/payments/billingcycle"
                icon={<CategoryOutlinedIcon />}
                selected={selected}
                setSelected={setSelected}
              />

              
                

                <Item
                title="Payments by Refund Status"
                to="/payments/refundstatus"
                icon={<CategoryOutlinedIcon />}
                selected={selected}
                setSelected={setSelected}
              />

              

                  </SubMenu>
                }
  
                {isMobile && 
                  <Item
                  title="Payments"
                  to="/payments"
                  icon={<PaymentOutlinedIcon />}
                  selected={selected}
                  setSelected={setSelected}
                  />

                }
                   
                  <Item
                  title="Production Schedule"
                  to="/productionschedule"
                  icon={<ScheduleOutlinedIcon />}
                  selected={selected}
                  setSelected={setSelected}
                  />

                   
  
              {!isMobile &&
                  <SubMenu
                    title="Fabrics"
                  to="/fabrics"
                    icon={<TextureOutlinedIcon />}
                    defaultOpen={false} // Control initial open state
                    style={{ color: colors.grey[100] }}
                    onClick={() => {
                    
                      if (!selected.includes("Fabric"))
                      {
                        setSelected("Fabric List");
                        navigate("/fabrics/list");
                      }
                    }}
                  >
                    <Item
                      title="Fabric List"
                      to="/fabrics/list"
                      icon={<ListIcon />}
                      selected={selected}
                      setSelected={setSelected}
                    />

                    

                    
                

                <Item
                title="Fabrics by Type"
                to="/fabrics/type"
                icon={<CategoryOutlinedIcon />}
                selected={selected}
                setSelected={setSelected}
              />

              

                  </SubMenu>
                }
  
                {isMobile && 
                  <Item
                  title="Fabrics"
                  to="/fabrics"
                  icon={<TextureOutlinedIcon />}
                  selected={selected}
                  setSelected={setSelected}
                  />

                }
                   
                  <Item
                  title="Inventory Management"
                  to="/inventorymanagement"
                  icon={<Inventory2OutlinedIcon />}
                  selected={selected}
                  setSelected={setSelected}
                  />

                   
  
              {!isMobile &&
                  <SubMenu
                    title="Measurements"
                  to="/measurements"
                    icon={<StraightenOutlinedIcon />}
                    defaultOpen={false} // Control initial open state
                    style={{ color: colors.grey[100] }}
                    onClick={() => {
                    
                      if (!selected.includes("Measurement"))
                      {
                        setSelected("Measurement List");
                        navigate("/measurements/list");
                      }
                    }}
                  >
                    <Item
                      title="Measurement List"
                      to="/measurements/list"
                      icon={<ListIcon />}
                      selected={selected}
                      setSelected={setSelected}
                    />

                    

                    
                

                <Item
                title="Measurements by Fit"
                to="/measurements/fit"
                icon={<CategoryOutlinedIcon />}
                selected={selected}
                setSelected={setSelected}
              />

              
                

                <Item
                title="Measurements by Clothing Type"
                to="/measurements/clothingtype"
                icon={<CategoryOutlinedIcon />}
                selected={selected}
                setSelected={setSelected}
              />

              
                

                <Item
                title="Measurements by Garment Type"
                to="/measurements/garmenttype"
                icon={<CategoryOutlinedIcon />}
                selected={selected}
                setSelected={setSelected}
              />

              
                

                <Item
                title="Measurements by Use Template"
                to="/measurements/usetemplate"
                icon={<CategoryOutlinedIcon />}
                selected={selected}
                setSelected={setSelected}
              />

              

                  </SubMenu>
                }
  
                {isMobile && 
                  <Item
                  title="Measurements"
                  to="/measurements"
                  icon={<StraightenOutlinedIcon />}
                  selected={selected}
                  setSelected={setSelected}
                  />

                }
                   
     
       {/*
           
          <Typography
            variant="h6"
            color={colors.grey[300]}
            sx={{ m: "15px 0 5px 20px" }}
          >

            Pages
          </Typography>
          <Item
            title="Calendar"
            to="/calendar"
            icon={<CalendarTodayOutlinedIcon />}
            selected={selected}
            setSelected={setSelected}
          />
     
          <Typography
            variant="h6"
            color={colors.grey[300]}
            sx={{ m: "15px 0 5px 20px" }}
          >
            Charts
          </Typography>
          <Item
            title="Bar Chart"
            to="/bar"
            icon={<BarChartOutlinedIcon />}
            selected={selected}
            setSelected={setSelected}
          />
          <Item
            title="Pie Chart"
            to="/pie"
            icon={<PieChartOutlineOutlinedIcon />}
            selected={selected}
            setSelected={setSelected}
          />
          <Item
            title="Line Chart"
            to="/line"
            icon={<TimelineOutlinedIcon />}
            selected={selected}
            setSelected={setSelected}
          />
          <Item
            title="Geography Chart"
            to="/geography"
            icon={<MapOutlinedIcon />}
            selected={selected}
            setSelected={setSelected}
          />
          */}

          <Typography
            variant="h6"
            color={colors.grey[300]}
            sx={{ m: "15px 0 5px 20px" }}
          >
            Account
          </Typography>

          {appUserRole === "admin" && (
          <Item
            title="Subscriptions"
            to="/subscriptions"
            icon={<SubscriptionsOutlinedIcon />}
            selected={selected}
            setSelected={setSelected}
          />
        )}

          {appUserRole === "admin" && (
            <Item
              title="User Accounts"
              to="/useraccounts"
              icon={<ManageAccountsOutlinedIcon />}
              selected={selected}
              setSelected={setSelected}
            />
          )}

          <Item
            title="Log Out"
            to="/logout"
            icon={<LogOffIcon />}
            selected={selected}
            setSelected={setSelected}
          />

        </Box>
      </Menu>
    </ProSidebar>
  </Box>

  );
};

export default Sidebar;
